<template>
  <div class="custom-print-template"  v-loading="loadAttr.loading" :element-loading-text="loadAttr.text">
    <el-header height="45px" class="print-head">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>打印模板</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!showNameInput">{{params.model_name || '未命名'}}<i
          class="el-icon-edit-outline name"
          @click="showNameInput=true"
        ></i></el-breadcrumb-item>
        <el-input class="name-input" ref="nameInput" v-else v-model="params.model_name" @change="showNameInput=false" @blur="showNameInput=false"></el-input>
      </el-breadcrumb>
      <div class="header-buttons">
        <el-dropdown split-button type="primary" @click="save">
          保存
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a @click="saveAndClose">保存并关闭</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="go-back" @click="closePage">X</span>
      </div>
    </el-header>
    <div class="print-content">
      <div class="print-field">
        <h2>字段列表</h2>
        <div class="title">点击字段进行插入</div>
        <div class="print-box">
          <el-input
            class="search-input"
            v-model="keywors"
            prefix-icon="el-icon-search"
            placeholder="请输入搜索内容"
            @change='searchColumn'
          ></el-input>
          <div class="columns">
            <div
              class="print-column"
              v-for="col in  this.columns"
              v-show="col.show"
              :key="col.id"
              @click="setColumn(col)"
            >
              <span>{{col.name}}</span>
              <i
                class="el-icon-right"
                @click="setColumn(col)"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="print-fx">
        <div
          class="print-menu"
          :style="{'width':this.mmConversionPx(page.width)+100+'px'}"
        >
          <div class="menu-group-wrapper">
            <div class="menu-item fontFamily">
              <el-dropdown trigger="click">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="字体"
                  placement="bottom"
                  :hide-after='1000'
                >
                  <span class="el-dropdown-link">
                    {{font.fontFamily|formatterFontFamily}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item,index) in fontFamilyOptions"
                    :key="index"
                  ><span @click="selectFontFamily(item.value)">{{item.label}}</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="menu-item fontSize">
              <el-dropdown
                trigger="click"
                @command="handleCommandSize"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="字号"
                  placement="bottom"
                >
                  <span class="el-dropdown-link">
                    {{font.fontSize|formatterFontSize}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </el-tooltip>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item,index) in fontSizeOptions"
                    :key="index"
                    :command="item.value"
                  >{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div
              class="menu-item bold"
              :class="{'boldSelect':font.bold}"
              @click="changeBold('bold')"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="粗体"
                placement="bottom"
              >
                <div class="menu-icon  bold"></div>
              </el-tooltip>
            </div>
            <div
              class="menu-item italic"
              :class="{'italicSelect':font.italic}"
              @click="changeBold('italic')"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="斜体"
                placement="bottom"
              >
                <div class="menu-icon  italic"></div>
              </el-tooltip>
            </div>
            <div
              class="menu-item underline"
              :class="{'underlineSelect':font.underline}"
              @click="changeBold('underline')"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="下划线"
                placement="bottom"
              >
                <div class="menu-icon  underline"></div>
              </el-tooltip>
            </div>
          </div>
          <div class="menu-group-wrapper">
            <div class="menu-item vertical-item">
              <el-dropdown trigger="click">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="水平居中"
                  placement="bottom"
                >
                  <span class="vertical"><img src="./assets/04c.png" /></span>
                </el-tooltip>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-with-img"
                >
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('paragraphAlign',0)"><img src="./assets/04c.png" /> 左对齐 </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('paragraphAlign',1)"><img src="./assets/05c.png" /> 居中对齐</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('paragraphAlign',2)"><img src="./assets/06c.png" /> 右对齐</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="menu-item vertical-item">
              <el-dropdown trigger="click">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="垂直居中"
                  placement="bottom"
                >
                  <span class="paragraph"><img src="./assets/07c.png" /></span>
                </el-tooltip>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-with-img"
                >
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('verticalAlign',0)"><img src="./assets/07c.png" /> 顶部对齐 </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('verticalAlign',1)"><img src="./assets/08c.png" /> 居中对齐</div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div @click="changeVerticalAlign('verticalAlign',2)"><img src="./assets/09c.png" /> 底部对齐</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="menu-item border">
              <el-dropdown
                @command="handleCommand"
                trigger="click"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="边框线"
                  placement="bottom"
                >
                  <span class="border"><img src="./assets/10c.png" /></span>
                </el-tooltip>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-with-img"
                >
                  <el-dropdown-item
                    v-for="(item,index) in borderOptions"
                    :key="index"
                    :command="item.value"
                  ><img :src="item.icon" />{{item.label}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="menu-group-wrapper no-border">
            <div class="menu-item upload">
              <el-upload
                class="rc-upload-control"
                name="files"
                action="/shared-api/files/uploadFiles"
                :headers="headers"
                :file-list="fileList"
                list-type="picture"
                :on-success="updataFile"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="插入图片"
                  placement="bottom"
                >
                  <img
                    src="./assets/17c.png"
                    alt="上传"
                  >
                </el-tooltip>
              </el-upload>
            </div>
            <div class="menu-item pageSize" @click="openDialogPageSize">
              <el-tooltip
                class="item"
                effect="dark"
                content="纸张设置"
                placement="bottom"
              >
                <span class="menu-icon pageSize"></span>
              </el-tooltip>
            </div>
          </div>
          <el-button
            class="preview-button"
            @click="previewDate"
          >预览</el-button>
        </div>
        <div class="print-handsongtable-box" :style="{'width':this.mmConversionPx(page.width) +80+'px','overflow':'auto','max-width':page.pageSize==='A3'&&page.width==='420'?'calc(100% - 100px)':'calc(100% - 254px)'}">
          <hot-table v-if="showTable" ref="testHot" :settings="hotSettings"></hot-table>
        </div>
      </div>
    </div>
    <el-dialog
      class="page-size-dialog"
      title="纸张设置"
      :visible.sync="pageDialog.dialogVisible"
      width="500px"
      center
    >
      <div class="page-box">
        <p>纸张大小</p>
        <el-select
          v-model="pageDialog.pageSize"
          placeholder="请选择"
          @change="changePageSize"
        >
          <el-option
            v-for="item in pageSizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="default-size">
          <span class="mr20">宽</span>
          <el-input
            class="mr10"
            v-model="pageDialog.dialogWidth"
            :disabled="pageDialog.disable"
          ></el-input>mm
          <span class="mr20">高</span>
          <el-input
            class="mr10"
            v-model="pageDialog.dialogHeight"
            :disabled="pageDialog.disable"
          ></el-input>mm
        </div>
        <p>纸张方向</p>
        <el-select
          v-model="pageDialog.dialogDirection"
          placeholder="请选择"
          @change="changePageDirection"
        >
          <el-option
            label="纵向"
            value="纵向"
          ></el-option>
          <el-option
            label="横向"
            value="横向"
          ></el-option>
        </el-select>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="comfire"
        >确 定</el-button>
        <el-button @click="pageDialog.dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="preview-dialog"
      title=""
      :visible.sync="preview.dialogVisible"
      width="700px"
      center>
      <div class="preview-box">
        <img :src="preview.address"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="preview.dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { HotTable } from '@handsontable/vue'
import tokenStorage from '@/plugins/tokenStorage'
import Handsontable from 'handsontable'
export default {
  data () {
    let width = this.mmConversionPx(210) + 20
    let definitionId = this.$route.query.definitionId
    let rowHeights = []
    let colWidths = []
    for (let i = 0; i < 30; i++) {
      rowHeights.push(24)
    }
    for (let i = 0; i < 8; i++) {
      colWidths.push(99)
    }
    return {
      isSelfEdit: false,
      loadAttr: {
        loading: false,
        text: '正在加载模板中'
      },
      showTable: false,
      headers: { 'Authorization': tokenStorage.getToken() },
      fileList: [],
      params: {},
      fontFamilyOptions: [{
        value: 'fontFamily微软雅黑',
        label: '微软雅黑'
      }, {
        value: 'fontFamily宋体',
        label: '宋体'
      }, {
        value: 'fontFamily楷体',
        label: '楷体'
      }, {
        value: 'fontFamily黑体',
        label: '黑体'
      }],
      fontSizeOptions: [{
        value: 'fontSize8',
        label: '8'
      }, {
        value: 'fontSize9',
        label: '9'
      },
      {
        value: 'fontSize10',
        label: '10'
      }, {
        value: 'fontSize12',
        label: '12'
      }, {
        value: 'fontSize14',
        label: '14'
      }, {
        value: 'fontSize16',
        label: '16'
      }, {
        value: 'fontSize18',
        label: '18'
      }, {
        value: 'fontSize24',
        label: '24'
      }, {
        value: 'fontSize30',
        label: '30'
      }, {
        value: 'fontSize36',
        label: '36'
      }],
      borderOptions: [{
        value: 'borderRight borderLeft borderTop borderBottom',
        icon: require('./assets/10c.png'),
        label: '所有'
      }, {
        icon: require('./assets/11c.png'),
        value: '外',
        label: '外'
      }, {
        icon: require('./assets/12c.png'),
        value: '',
        label: '无'
      }, {
        value: 'borderTop',
        label: '顶',
        icon: require('./assets/13c.png')
      }, {
        value: 'borderRight',
        label: '右',
        icon: require('./assets/14c.png')
      }, {
        value: 'borderBottom',
        label: '底',
        icon: require('./assets/15c.png')
      },
      {
        value: 'borderLeft',
        label: '左',
        icon: require('./assets/16c.png')
      }],
      pageSizeOptions: [{
        value: 'A3',
        label: 'A3'
      }, {
        value: 'A4',
        label: 'A4'
      }, {
        value: 'A5',
        label: 'A5'
      }, {
        value: 'B5',
        label: 'B5'
      }],
      font: {
        fontFamily: 'fontFamily微软雅黑',
        fontSize: 'fontSize10',
        bold: false,
        borderType: '',
        italic: false,
        underline: false
      },
      pageDialog: {
        dialogVisible: false,
        dialogWidth: 210,
        dialogHeight: 297,
        dialogDirection: '纵向',
        allHeightLength: 0,
        allwidthLenght: 0,
        disable: true
      },
      page: {
        pageSize: 'A4',
        width: 210,
        height: 297,
        direction: '纵向'
      },
      preview: {
        dialogVisible: false,
        address: ''
      },
      allColWidth: {},
      definitionId,
      columns: [],
      tables: [],
      selectCells: [],
      piclist: [],
      showNameInput: false,
      keywors: '',
      hot: {},
      hotSettings: {
        license: 'non-commercial and evaluation',
        cell: [
          // {row: 0, col: 0, className: 'htRight htMiddle', editor: false}, // 右对齐垂直居中，只读
          // {row: 1, col: 1, className: 'htLeft'} // 左对齐
        ],
        startRows: 30,
        minRows: 1, // 最小行列
        minCols: 1,
        colWidths: colWidths,
        rowHeights: rowHeights,
        manualColumnResize: true,
        manualRowResize: true,
        rowHeaders (index) {
          return ''
        },
        rowHeaderWidth: 10,
        width,
        colHeaders (index) {
          return ''
        },
        currentRowClassName: 'currentRow', // 为选中行添加类名，可以更改样式
        currentColClassName: 'currentCol', // 为选中列添加类名,
        mergeCells: [],
        stretchH: 'none',
        contextMenu: {
          items: {
            'copy': {
              name: '复制'
            },
            'cut': {
              name: '剪切'
            },
            'hsep1': '---------', // 提供分隔线
            'row_above': {
              name: '上方插入行'
            },
            'row_below': {
              name: '下方插入行'
            },
            'col_left': {
              name: '左方插入列'
            },
            'col_right': {
              name: '右方插入列'
            },
            'mergeCells': {
              name: '合并/取消合并'
            },
            'remove_row': {
              name: '移除该行'
            },
            'remove_col': {
              name: '移除该列'
            },
            'clear_custom': {
              name: '清空单元格的值',
              callback (ley, options) {
                for (let i = options[0].start.row; i <= options[0].end.row; i++) {
                  for (let j = options[0].start.col; j <= options[0].end.col; j++) {
                    this.setDataAtCell(i, j, null)
                    this.setCellMeta(i, j, 'readOnly', false)
                  }
                }
              }
            }
          }
        },
        afterChange: (changes, source) => {
          if (changes && source === 'edit' && this.isSelfEdit) {
            // isSelfEdit通过接口编辑进来的时候执行这个方法
            // 只有用户自己手动改完内容需要把高度也延长
            let col = changes[0][1]
            let row = changes[0][0]
            setTimeout(() => {
              if (this.$refs.testHot.hotInstance.getCell(row, col)) {
                let height = this.$refs.testHot.hotInstance.getCell(row, col).offsetHeight
                if (height) {
                  let mergedCells = this.getMergedCellsByColAndRow(row, col)
                  let r = this.$refs.testHot.hotInstance.getPlugin('ManualRowResize')
                  if (mergedCells) {
                    height = height / (mergedCells.rowspan)
                    for (let i = 0; i < mergedCells.rowspan; i++) {
                      r.setManualSize(row + i, height)
                    }
                  } else {
                    r.setManualSize(row, height)
                  }
                  this.$refs.testHot.hotInstance.render()
                }
              }
            }, 100)
          }
        },
        afterOnCellMouseOver: (event, coords, td) => {
          // 存拖动列宽前的值
          this.allColWidth[coords.col] = this.$refs.testHot.hotInstance.getColWidth(coords.col)
        },
        // 手动改行宽后调用
        afterColumnResize: (col, size) => {
          let r = this.$refs.testHot.hotInstance.getPlugin('ManualColumnResize')
          r.setManualSize(col, size)
          let cha = this.allColWidth[col] - this.$refs.testHot.hotInstance.getColWidth(col)
          // 小于0 说明往右拖，那下一个得减少相应的宽度 大于0下一个是加响应宽度
          let nextColWidth = this.$refs.testHot.hotInstance.getColWidth(col + 1) + cha
          if (nextColWidth <= 20) {
            r.setManualSize(col, this.allColWidth[col])
          } else {
            r.setManualSize(col + 1, nextColWidth)
            this.allColWidth[col] = size
          }
          this.$refs.testHot.hotInstance.render()
        },
        afterRowResize: (row, size) => {
          let r = this.$refs.testHot.hotInstance.getPlugin('ManualRowResize')
          r.setManualSize(row, size)
          this.$refs.testHot.hotInstance.render()
        },
        beforeRemoveCol: (index, amount) => {
          let removeWidth = 0
          for (let i = 0; i < amount; i++) {
            removeWidth += this.$refs.testHot.hotInstance.getColWidth(index + i)
          }
          let colAr = []
          for (let i = 0; i < this.$refs.testHot.hotInstance.countCols(); i++) {
            colAr.push(this.$refs.testHot.hotInstance.getColWidth(i))
          }
          colAr.splice(index, amount)
          if (colAr[index + 1]) {
            colAr[index + 1] = colAr[index + 1] + removeWidth
          } else if (colAr[index - 1]) {
            colAr[index - 1] = colAr[index - 1] + removeWidth
          } else {
            for (let i = 0; i < colAr.length; i++) {
              if (colAr[i]) {
                colAr[i] = colAr[i] + removeWidth
                break
              }
            }
          }
          let r = this.$refs.testHot.hotInstance.getPlugin('ManualColumnResize')
          for (let j = 0; j < colAr.length; j++) {
            r.setManualSize(j, colAr[j])
          }
        },
        // 插入一列
        afterCreateCol: (index, amount, source) => {
          let colAr = []
          for (let i = 0; i < this.$refs.testHot.hotInstance.countCols() - 1; i++) {
            colAr.push(this.$refs.testHot.hotInstance.getColWidth(i))
          }
          colAr.splice(index, 0, 30)
          if (source === 'ContextMenu.columnLeft' && colAr[index + 1] > 60) {
            colAr[index + 1] = colAr[index + 1] - 30
          } else if (source === 'ContextMenu.columnRight' && colAr[index - 1] > 60) {
            colAr[index - 1] = colAr[index - 1] - 30
          } else {
            for (let i = 0; i < colAr.length; i++) {
              if (colAr[i] > 60) {
                colAr[i] = colAr[i] - 30
                break
              }
            }
          }
          let r = this.$refs.testHot.hotInstance.getPlugin('ManualColumnResize')
          for (let j = 0; j < colAr.length; j++) {
            r.setManualSize(j, colAr[j])
          }
        },
        // 插入新行
        afterCreateRow: (index, amount) => {
          let colAr = []
          for (let i = 0; i < this.$refs.testHot.hotInstance.countRows() - 1; i++) {
            colAr.push(this.$refs.testHot.hotInstance.getRowHeight(i))
          }
          colAr.splice(index, 0, 24)
          let r = this.$refs.testHot.hotInstance.getPlugin('ManualRowResize')
          for (let j = 0; j < colAr.length; j++) {
            r.setManualSize(j, colAr[j])
          }
        },
        // 列宽被修改时调用
        modifyColWidth: (width, col) => {
          // this.hotSettings.colWidths[col] = width
        },
        modifyRowHeight: (height, row) => {
          // this.cloneRowHeights[row] = height
        },
        outsideClickDeselects: (event) => {
          // 点击格子以外的地方会触发
          return false
        },
        afterSelection: (r, c, r2, c2) => {
          // 当一个或多个单元格被选中后调用
          let currentClassName = this.$refs.testHot.hotInstance.getCellMeta(r, c).className
          if (currentClassName) {
            currentClassName.split(' ').forEach(m => {
              if (m === 'italic') {
                this.font.italic = true
              } else if (m === 'underline') {
                this.font.underline = true
              } else if (m === 'bold') {
                this.font.bold = true
              } else if (m.includes('fontFamily')) {
                this.font.fontFamily = m
              } else if (m.includes('fontSize')) {
                this.font.fontSize = m
              }
            })
          } else {
            this.font = {
              fontFamily: 'fontFamily微软雅黑',
              fontSize: 'fontSize10',
              bold: false,
              borderType: '',
              italic: false,
              underline: false
            }
          }
        },
        trimWhitespace: false,
        renderer: function (instance, td, row, col, prop, value, cellProperties, picAddress) {
          // 根据单元格的值取渲染html
          let escaped = Handsontable.helper.stringify(value)
          Handsontable.renderers.HtmlRenderer.apply(this, arguments)
          // 判断条件
          if (escaped && escaped.indexOf('http') === 0) {
            let imgdel = document.createElement('div')
            imgdel.className = 'print-image-value'
            imgdel.style.backgroundImage = `url('${escaped}')`
            td.appendChild(imgdel)
            Handsontable.dom.empty(td)
            td.appendChild(imgdel)
          } else {
            // render as text
            Handsontable.renderers.TextRenderer.apply(this, arguments)
          }
          return td
        }

      }
    }
  },
  name: 'CustomPrint',
  components: {
    HotTable
  },
  created () {
    this.loadColumns()
    let params = {'domain': document.domain}
    this.$axios.get('/system-api/application/getSettingByDomain', {params}).then(res => {
      if (res.data && res.data.data) {
        document.title = res.data.data.applicationName
      }
    })
  },
  mounted () {
    document.onclick = () => {
      if (this.showNameInput) {
        this.$nextTick(() => {
          this.$refs.nameInput.focus()
        })
      }
    }
    this.loadTemplate()
  },
  filters: {
    formatterFontFamily (value) {
      if (!value) return ''
      value = value.split('fontFamily')[1]
      return value
    },
    formatterFontSize (value) {
      if (!value) return ''
      value = value.split('fontSize')[1]
      return value
    }
  },
  watch: {
    keywors (val) {
      this.columns.forEach(m => {
        m.show = m.name.includes(val)
      })
    }
  },
  methods: {
    loadTemplate () {
      this.loadAttr.loading = true
      this.$axios.get(`/shared-api/print/${this.$route.query.id}`)
        .then(res => {
          this.loadAttr.loading = false
          this.showTable = true
          this.params = res.data
          this.page = this.params.page ? this.params.page : {width: 210, pageSize: 'A4', height: 297, direction: '纵向'}
          this.hotSettings.width = this.mmConversionPx(this.page.width) + 20
          if (this.params.colWidths.length) {
            this.hotSettings.colWidths = this.$_.cloneDeep(this.params.colWidths)
          }
          this.hotSettings.startCols = this.hotSettings.colWidths.length
          this.hotSettings.mergeCells = this.params.mergeCells
          this.$nextTick(() => {
            this.hot = this.$refs.testHot.hotInstance
            // 设置单元格为选中状态
            this.$refs.testHot.hotInstance.selectCell(0, 0, 0, 0)
            this.params.data.forEach((m, i) => {
              m.forEach((n, j) => {
                if (n) {
                  if (n.type === 'pic') {
                    let picAddress = n.text
                    let td = this.$refs.testHot.hotInstance.getCell(i, j)
                    let imgdel = document.createElement('div')
                    imgdel.className = 'print-image-value'
                    imgdel.style.backgroundImage = `url('${picAddress}')`
                    td.appendChild(imgdel)
                    this.$refs.testHot.hotInstance.setDataAtCell(i, j, picAddress)
                    this.$refs.testHot.hotInstance.setCellMeta(i, j, 'readOnly', true)
                  } else {
                    this.$refs.testHot.hotInstance.setDataAtCell(i, j, n.text)
                  }
                  this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', n.className)
                  // 设置高度 在和宽度一起的地方会设置失效
                  if (this.params.rowHeights.length) {
                    let r = this.$refs.testHot.hotInstance.getPlugin('ManualRowResize')
                    for (let j = 0; j < this.params.rowHeights.length; j++) {
                      r.setManualSize(j, this.params.rowHeights[j])
                    }
                  }
                  this.$refs.testHot.hotInstance.render()
                }
              })
            })
            this.isSelfEdit = true
          })
        })
        .catch(() => {
          this.loadAttr.loading = false
        })
    },
    loadColumns () {
      let type = this.$route.query.type
      // 默认报表
      let url = type === 'report' || type === 'dataSourceReport' ? `/report-api/report/definition/getColumnsForPrint/${this.definitionId}` : type === 'process' ? `/process-api/processes/getColumnsForPrint/${this.definitionId}` : `/form-api/defines/getColumnsForPrint/${this.definitionId}`
      this.$axios.get(`${url}`)
        .then(data => {
          data.data.forEach(m => {
            m.show = true
          })
          this.columns = data.data
        })
    },
    searchColumn () {
      this.columns.forEach(m => {
        m.show = m.name.includes(this.keywors)
      })
    },
    handleCommand (type) {
      this.selectSetBorder(type)
    },
    selectSetBorder (val) {
      if (!val) {
        this.font.borderType = val
        let sel = this.$refs.testHot.hotInstance.getSelected()
        if (sel) {
          sel.forEach(m => {
            for (let i = m[0]; i <= m[2]; i++) {
              for (let j = m[1]; j <= m[3]; j++) {
                let cname = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes('border')).join(' ')
                }
                let className = cname ? cname + ' ' + this.font.borderType : this.font.borderType
                this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', className)
                this.$refs.testHot.hotInstance.render()
              }
            }
          })
        }
      } else if (val === '外') {
        let sel = this.$refs.testHot.hotInstance.getSelected()
        if (sel) {
          sel.forEach(m => {
            for (let i = m[0]; i <= m[2]; i++) {
              for (let j = m[1]; j <= m[3]; j++) {
                let cname = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes('border')).join(' ')
                  if (i >= m[0] && i <= m[2] && j === m[1]) {
                    cname = cname ? cname + ' ' + 'borderLeft' : 'borderLeft'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + 'borderTop' : 'borderTop'
                  }
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                } else {
                  if (i >= m[0] && i <= m[2] && j === m[1]) {
                    cname = cname ? cname + ' ' + 'borderLeft' : 'borderLeft'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + 'borderTop' : 'borderTop'
                  }
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                }
                this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', cname)
                this.$refs.testHot.hotInstance.render()
              }
            }
          })
        }
      } else if (val === 'borderRight borderLeft borderTop borderBottom') {
        let sel = this.$refs.testHot.hotInstance.getSelected()
        if (sel) {
          sel.forEach(m => {
            for (let i = m[0]; i <= m[2]; i++) {
              for (let j = m[1]; j <= m[3]; j++) {
                let cname = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes('border')).join(' ')
                  if (i >= m[0] && i <= m[2] && j === m[1]) {
                    cname = cname ? cname + ' ' + 'borderLeft' : 'borderLeft'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + 'borderTop' : 'borderTop'
                  }
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                  // 上面是画四周的线，下面两个是里面的线
                  if ((i >= m[0] || i <= m[2]) && (j >= m[1] && j <= m[3])) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && (i >= m[0] && i < m[2])) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                } else {
                  if (i >= m[0] && i <= m[2] && j === m[1]) {
                    cname = cname ? cname + ' ' + 'borderLeft' : 'borderLeft'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + 'borderTop' : 'borderTop'
                  }
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                  // 上面是画四周的线，下面两个是里面的线
                  if ((i >= m[0] || i <= m[2]) && (j >= m[1] && j <= m[3])) {
                    cname = cname ? cname + ' ' + 'borderRight' : 'borderRight'
                  }
                  if ((j >= m[1] || j <= m[3]) && (i >= m[0] && i < m[2])) {
                    cname = cname ? cname + ' ' + 'borderBottom' : 'borderBottom'
                  }
                }
                this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', cname)
                this.$refs.testHot.hotInstance.render()
              }
            }
          })
        }
      } else {
        this.handwrapBorder(val)
      }
    },
    handwrapBorder (type) {
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              let cname = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
              if (type === 'borderRight') {
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes(type)).join(' ')
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                } else {
                  if ((i >= m[0] || i <= m[2]) && j === m[3]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                }
              } else if (type === 'borderLeft') {
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes(type)).join(' ')
                  if ((i >= m[0] || i <= m[2]) && j === m[1]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                } else {
                  if ((i >= m[0] || i <= m[2]) && j === m[1]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                }
              } else if (type === 'borderBottom') {
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes(type)).join(' ')
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                } else {
                  if ((j >= m[1] || j <= m[3]) && i === m[2]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                }
              } else if (type === 'borderTop') {
                if (cname) {
                  cname = cname.split(' ').filter(n => !n.includes(type)).join(' ')
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                } else {
                  if ((j >= m[1] || j <= m[3]) && i === m[0]) {
                    cname = cname ? cname + ' ' + type : type
                  }
                }
              }
              this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', cname)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    changeBold (type) {
      let str
      switch (type) {
        case 'bold':
          this.font.bold = !this.font.bold
          str = this.font.bold ? 'bold' : ''
          break
        case 'italic':
          this.font.italic = !this.font.italic
          str = this.font.italic ? 'italic' : ''
          break
        case 'underline':
          this.font.underline = !this.font.underline
          str = this.font.underline ? 'underline' : ''
          break
      }
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              let allClass = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
              let className = null
              if (str) {
                className = allClass ? allClass.split(' ').filter(n => !n.includes(str)).join(' ') : ''
                className = className ? className + ' ' + str : str
              } else {
                className = allClass ? allClass.split(' ').filter(n => !n.includes(type)).join(' ') : ''
              }
              this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', className)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    selectFontFamily (value) {
      this.font.fontFamily = value
      let str = value
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              let allClass = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
              let className = allClass ? allClass.split(' ').filter(n => !n.includes('fontFamily')).join(' ') : ''
              className = className ? className + ' ' + str : str
              this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', className)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    handleCommandSize (type) {
      this.changeFontSize(type)
    },
    changeFontSize (val) {
      this.font.fontSize = val
      let str = val
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              let allClass = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
              let className = allClass ? allClass.split(' ').filter(n => !n.includes('fontSize')).join(' ') : ''
              className = className ? className + ' ' + str : str
              this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', className)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    changeVerticalAlign (type, number) {
      let str = type + number
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              let allClass = this.$refs.testHot.hotInstance.getCellMeta(i, j).className
              let className = allClass ? allClass.split(' ').filter(n => !n.includes(type)).join(' ') : ''
              className = className ? className + ' ' + str : str
              this.$refs.testHot.hotInstance.setCellMeta(i, j, 'className', className)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    getMergedCellsByColAndRow (row, col) {
      let belongmergedCell = null
      this.$refs.testHot.hotInstance.getPlugin('MergeCells').mergedCellsCollection.mergedCells.forEach(m => {
        for (let i = m.row; i < m.row + m.rowspan; i++) {
          for (let j = m.col; j < m.col + m.colspan; j++) {
            if (row === i && col === j) {
              belongmergedCell = m
            }
          }
        }
      })
      return belongmergedCell
    },
    getDownLoadUrl () {
      return sessionStorage.getItem('ossDownloadUrl')
    },
    updataFile (res, file, fileList) {
      let hot = this.$refs.testHot.hotInstance
      let cells = this.$refs.testHot.hotInstance.getSelected()[0]
      let url = res[0].result.dir
      let picAddress = `${this.getDownLoadUrl(url)}${url}`
      let td = hot.getCell(cells[0], cells[1])
      if (td && td.querySelector('.print-image-value')) {
        this.$refs.testHot.hotInstance.setDataAtCell(cells[0], cells[1], picAddress)
      } else {
        let imgdel = document.createElement('div')
        imgdel.className = 'print-image-value'
        imgdel.style.backgroundImage = `url('${picAddress}')`
        td.appendChild(imgdel)
        this.$refs.testHot.hotInstance.setDataAtCell(cells[0], cells[1], picAddress)
        this.$refs.testHot.hotInstance.setCellMeta(cells[0], cells[1], 'readOnly', true)
      }
    },
    sum (arr) {
      let s = 0
      for (let i = arr.length - 1; i >= 0; i--) {
        s += arr[i]
      }
      return s
    },
    handleDate () {
      let hot = this.$refs.testHot.hotInstance
      var examData = hot.getData()
      let newData = examData.map((m, i) => {
        return m.map((n, col) => {
          let td = hot.getCell(i, col)
          if (n && td && td.querySelector('.print-image-value')) {
            let pic = td.querySelector('.print-image-value').style.backgroundImage.slice(5).slice(0, -2)
            n = pic
          }
          let classNames = hot.getCellMeta(i, col).className
          if (n === null && classNames === undefined) {
            return null
          } else {
            let type = 'text'
            if (n && n.includes('https')) {
              type = 'pic'
            }
            return { 'text': n, 'type': type, 'className': classNames || '' }
          }
        })
      })
      // 取最后一个有数据的行
      let hasValueIndex = 0
      newData.forEach((el, index) => {
        if (el.find(el => el !== null)) {
          hasValueIndex = index
        }
      })
      // 合并单元格最后一行但是是空数据的处理
      this.$refs.testHot.hotInstance.getPlugin('MergeCells').mergedCellsCollection.mergedCells.forEach(m => {
        if (hasValueIndex < m.row + m.rowspan) {
          hasValueIndex = m.row + m.rowspan
        }
      })
      newData = newData.slice(0, hasValueIndex + 1)
      this.params.mergeCells = []
      this.$refs.testHot.hotInstance.getPlugin('MergeCells').mergedCellsCollection.mergedCells.forEach(m => {
        this.params.mergeCells.push({ 'row': m.row, 'col': m.col, 'rowspan': m.rowspan, 'colspan': m.colspan })
      })
      this.params.colWidths = []
      for (let i = 0; i < this.$refs.testHot.hotInstance.countCols(); i++) {
        this.params.colWidths.push(this.$refs.testHot.hotInstance.getColWidth(i))
      }
      this.params.rowHeights = []
      for (let i = 0; i < this.$refs.testHot.hotInstance.countRows(); i++) {
        this.params.rowHeights.push(this.$refs.testHot.hotInstance.getRowHeight(i))
      }
      this.params.mmRowHeights = []
      for (let i = 0; i < this.params.rowHeights.length; i++) {
        this.params.mmRowHeights.push(this.pxConversionMm(this.params.rowHeights[i]))
      }
      this.params.serverType = this.$route.query.type
      this.params.definitionId = this.$route.query.definitionId
      this.params.page = this.page
      this.params.data = newData
    },
    previewDate () {
      this.loadAttr.loading = true
      this.loadAttr.text = '正在生成'
      this.handleDate()
      this.$axios.post(`/shared-api/print/preview`, this.params).then(res => {
        this.loadAttr.loading = false
        if (res.status === 200) {
          this.preview.dialogVisible = true
          let path = res.data.result.dir
          this.preview.address = `${sessionStorage.getItem('ossDownloadUrl')}${path}`
        }
      })
        .catch(() => {
          this.loadAttr.loading = false
        })
    },
    save () {
      this.loadAttr.loading = true
      this.loadAttr.text = '正在保存'
      this.handleDate()
      this.$axios.post(`/shared-api/print`, this.params).then(res => {
        this.loadAttr.loading = false
        this.$message({
          message: '保存成功',
          center: true,
          customClass: 'message-form-save',
          type: 'success'
        })
      })
        .catch(() => {
          this.loadAttr.loading = false
        })
    },
    saveAndClose () {
      this.loadAttr.loading = true
      this.loadAttr.text = '正在保存'
      this.handleDate()
      this.$axios.post(`/shared-api/print`, this.params).then(res => {
        this.loadAttr.loading = false
        this.$message({
          message: '保存成功',
          center: true,
          customClass: 'message-form-save',
          type: 'success'
        })
        this.closePage()
      })
    },
    closePage () {
      window.close()
    },
    onDragStart (event, col) {
      event.dataTransfer.setData('text', JSON.stringify(col))
    },
    allowDrop (event) {
      event.preventDefault()
    },
    equalsTo (cell) {
      return this.hotSettings.mergeCells.find(n => n.row === cell.row && n.col === cell.col && n.rowspan === cell.rowspan && n.colspan === cell.colspan)
    },
    drop (event) {
      if (event.toElement.tagName === 'TD') {
        let columnName = JSON.parse(event.dataTransfer.getData('text')).name
        let par = `@${columnName}@`
        event.toElement.classList.add('current111')
        let index = 0
        Object.values(event.srcElement.parentNode.cells).forEach((m, i) => {
          if (m.className.includes('current111')) {
            index = i
          }
        })
        this.$refs.testHot.hotInstance.setDataAtCell(event.srcElement.parentNode.sectionRowIndex, index - 1, par)
        this.$refs.testHot.hotInstance.render()
      }
    },
    setColumn (col) {
      let par = `@${col.name}@`
      let sel = this.$refs.testHot.hotInstance.getSelected()
      if (sel) {
        sel.forEach(m => {
          for (let i = m[0]; i <= m[2]; i++) {
            for (let j = m[1]; j <= m[3]; j++) {
              this.$refs.testHot.hotInstance.setDataAtCell(i, j, par)
              this.$refs.testHot.hotInstance.render()
            }
          }
        })
      }
    },
    openDialogPageSize () {
      this.pageDialog.dialogVisible = true
      this.pageDialog.dialogWidth = this.page.width
      this.pageDialog.pageSize = this.page.pageSize
      this.pageDialog.dialogHeight = this.page.height
      this.pageDialog.dialogDirection = this.page.direction
    },
    changePageSize (val) {
      if (val === 'A3') {
        this.pageDialog.dialogWidth = 297
        this.pageDialog.dialogHeight = 420
        this.pageDialog.disable = true
      } else if (val === 'A4') {
        this.pageDialog.dialogWidth = 210
        this.pageDialog.dialogHeight = 297
        this.pageDialog.disable = true
      } else if (val === 'B5') {
        this.pageDialog.dialogWidth = 182
        this.pageDialog.dialogHeight = 257
        this.pageDialog.disable = true
      } else if (val === 'A5') {
        this.pageDialog.dialogWidth = 148
        this.pageDialog.dialogHeight = 210
        this.pageDialog.disable = true
      } else {
        this.pageDialog.dialogWidth = ''
        this.pageDialog.dialogHeight = ''
        this.pageDialog.disable = false
      }
      this.pageDialog.dialogDirection = '纵向'
    },
    changePageDirection (val) {
      let temp = null
      temp = this.pageDialog.dialogWidth
      this.pageDialog.dialogWidth = this.pageDialog.dialogHeight
      this.pageDialog.dialogHeight = temp
    },
    comfire () {
      if (this.page.pageSize !== this.pageDialog.pageSize ||
          this.page.width !== this.pageDialog.dialogWidth ||
          this.page.height !== this.pageDialog.dialogHeight ||
          this.page.direction !== this.pageDialog.dialogDirection) {
        this.$confirm('', '您确定切换纸张吗？确定后设置的样式会重置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'deleMessageBox',
          distinguishCancelAndClose: true,
          center: true
        })
          .then(() => {
            if (document.querySelector('.page_split')) {
              document.querySelector('.handsontable').querySelector('.wtHider').removeChild(document.querySelector('.page_split'))
            }
            this.page.pageSize = this.pageDialog.pageSize
            this.page.width = this.pageDialog.dialogWidth
            this.page.height = this.pageDialog.dialogHeight
            this.page.direction = this.pageDialog.dialogDirection
            this.hotSettings.width = this.mmConversionPx(this.page.width) + 20
            let newWidth = this.mmConversionPx(this.page.width) / this.$refs.testHot.hotInstance.countCols()
            let r = this.$refs.testHot.hotInstance.getPlugin('ManualColumnResize')
            for (let i = 0; i < this.$refs.testHot.hotInstance.countCols(); i++) {
              r.setManualSize(i, newWidth)
            }
            if (document.querySelector('.handsontable').querySelector('.wtHider').offsetHeight > this.page.height * 3.5) {
              let splitLine = document.createElement('DIV')
              splitLine.style.top = this.page.height * 3.5 + 'px'
              splitLine.className = 'page_split'
              document.querySelector('.handsontable').querySelector('.wtHider').appendChild(splitLine)
            }
            this.$refs.testHot.hotInstance.render()
            this.pageDialog.dialogVisible = false
          })
      } else {
        if (document.querySelector('.page_split')) {
          document.querySelector('.handsontable').querySelector('.wtHider').removeChild(document.querySelector('.page_split'))
        }
        this.page.pageSize = this.pageDialog.pageSize
        this.page.width = this.pageDialog.dialogWidth
        this.page.height = this.pageDialog.dialogHeight
        this.page.direction = this.pageDialog.dialogDirection
        this.hotSettings.width = this.mmConversionPx(this.page.width) + 20
        let newWidth = this.mmConversionPx(this.page.width) / this.$refs.testHot.hotInstance.countCols()
        let r = this.$refs.testHot.hotInstance.getPlugin('ManualColumnResize')
        for (let i = 0; i < this.$refs.testHot.hotInstance.countCols(); i++) {
          r.setManualSize(i, newWidth)
        }
        if (document.querySelector('.handsontable').querySelector('.wtHider').offsetHeight > this.page.height * 3.5) {
          let splitLine = document.createElement('DIV')
          splitLine.style.top = this.page.height * 3.5 + 'px'
          splitLine.className = 'page_split'
          document.querySelector('.handsontable').querySelector('.wtHider').appendChild(splitLine)
        }
        this.$refs.testHot.hotInstance.render()
        this.pageDialog.dialogVisible = false
      }
    },
    conversion_getDPI () {
      let arrDPI = []
      if (window.screen.deviceXDPI) {
        arrDPI[0] = window.screen.deviceXDPI
        arrDPI[1] = window.screen.deviceYDPI
      } else {
        let tmpNode = document.createElement('DIV')
        tmpNode.style.cssText = 'width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden'
        document.body.appendChild(tmpNode)
        arrDPI[0] = parseInt(tmpNode.offsetWidth)
        arrDPI[1] = parseInt(tmpNode.offsetHeight)
        tmpNode.parentNode.removeChild(tmpNode)
      }
      return arrDPI
    },
    mmConversionPx (value) {
      let inch = value / 25.4
      let cvalue = inch * this.conversion_getDPI()[0]
      return cvalue
    },
    pxConversionMm (value) {
      let inch = value / this.conversion_getDPI()[0]
      let cvalue = inch * 25.4
      return cvalue
    }

  }
}
</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style lang="scss">
  .custom-print-template {
    height: 100%;
    .table {
      td {
        border: 1px solid #000;
        height: 20px;
        width: 20px;
      }
    }
    .el-upload-list {
      display: none;
    }
    .print-head {
      background: #fff;
      line-height: 45px;
      box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
      padding: 0 12px 0 26px;
      border-bottom: 1px solid #d6e2f4;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
      .el-breadcrumb {
        display: inline-block;
        line-height: 45px;
        span {
          font-size: 16px;
          color: #1a1a1a;
        }
        .name {
          vertical-align: middle;
          margin-left: 10px;
          color: #999999;
          cursor: pointer;
          &:hover,
          &:active {
            color: #54abf1;
          }
        }
        .name-input {
          display: inline-block;
          width: 267px;
        }
      }
      .header-buttons {
        float: right;
        .el-dropdown .el-button {
          padding: 5px 5px;
        }
        .go-back {
          color: #c2c3c4;
          margin-left: 32px;
          cursor: pointer;
        }
      }
    }
    .print-content {
      height: calc(100% - 50px);
      background: #fff;
      .print-field {
        width: 242px;
        float: left;
        border: 1px solid rgba(222, 222, 222, 1);
        border-radius: 4px;
        margin: 10px;
        height: 98%;
        background: #fff;
        .title {
          height: 28px;
          background: #f2f2f4;
          text-align: center;
          line-height: 28px;
        }
        h2 {
          font-weight: 400;
          font-size: 16px;
          text-align: center;
          height: 36px;
          line-height: 36px;
        }

        .print-box {
          padding: 15px;
          height: calc( 100% - 55px);
          .search-input {
            margin-bottom: 10px;
          }
          .columns {
            height: calc(100% - 40px);
            overflow: auto;
          }

          .print-column {
            background: #fff;
            font-size: 12px;
            border: 1px dashed transparent;
            margin-bottom: 5px;
            cursor: pointer;
            padding-left: 14px;
            color: #222;
            overflow: hidden;
            height: 30px;
            line-height: 30px;
            text-align: left;
            text-overflow: ellipsis;
            white-space: nowrap;
            > span {
              width: 150px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
            }
            i {
              visibility: hidden;
              vertical-align: top;
              margin-top: 8px;
            }
            &:hover {
              background: #E6EFFB;
              i {
                color: #B0BCCD;
                visibility: visible;
              }
            }
            &:active {
              background: #E6EFFB;
              color: #54ABF1;
              i {
                visibility: visible;
                color:#54ABF1;
              }
            }
          }
        }
      }

      .print-fx {
        float: left;
        width: calc(100% - 272px);
        text-align: center;
        background: #eff5fa;
        height: 100%;

        #hot-display-license-info {
          display: none;
        }
        .print-menu {
          margin: 0 auto;
          text-align: left;
          height: 40px;
          margin-top: 15px;
          position: relative;
          max-width: calc(100% - 280px);

          .menu-group-wrapper {
            padding: 0 10px;
            display: inline-block;
            position: relative;
            height: 28px;
            overflow: hidden;
            &::after {
              content: "";
              width: 1px;
              height: 10px;
              position: absolute;
              top: 7px;
              right: 3px;
              background: #cfd7e2;
            }
            &.no-border {
              padding-top: 3px;
              &::after {
                content: "";
                display: none;
              }
            }
            .menu-item {
              float: left;
              margin-right: 5px;
              border-color: transparent;
              >.el-tooltip {
                padding: 2px 5px;
              }
              .el-dropdown {
                line-height: 24px;
                height: 24px;
                >.el-tooltip {
                  padding: 2px 5px;
                }
              }
              .vertical,
              .paragraph,
              .border {
                padding: 2px 10px;
                display: inline-block;
              }
              > div , img {
                cursor: pointer;
                display: inline-block;
                margin: 0 auto;
              }
              &:hover {
                background: #cddcf2;
                border-radius: 4px;
              }
              .el-dropdown {
                color: #000;
                &.w28{
                  width: 28px;
                  text-align: center;
                }
              }
            }
            .bold,.italic,.underline{
              padding: 3px 8px;
            }
            .menu-item.pageSize {
              padding: 2px 10px;
            }
            .border,.vertical-item {
              margin-right: 5px;
              .el-dropdown>.el-tooltip {
                padding: 2px 8px;
              }
            }
            .upload{
              padding: 3px 10px;
            }
            .vertical {
              > div {
                display: inline-block;
              }
            }
            .menu-icon {
              width: 18px;
              height: 14px;
              display: inline-block;
              background: url("./assets/01c.png") no-repeat;
              background-size: contain;
              &.italic {
                background: url("./assets/02c.png") no-repeat;
                background-size: contain;
              }
              &.underline {
                background: url("./assets/03c.png") no-repeat;
                background-size: contain;
              }
              &.pageSize {
                cursor: pointer;
                width: 14px;
                height: 14px;
                display: inline-block;
                background: url("./assets/21c.png") no-repeat;
                background-size: contain;
                margin-top: 1px;
              }
            }
            // .boldSelect {
            //   .menu-icon {
            //      border-color: #D9D9D9;
            //      background-color: #F3F6FC;
            //   }
            // }
            //  .italicSelect,.underlineSelect {
            //   .menu-icon {
            //      border-color: #D9D9D9;
            //      background-color: #F3F6FC;
            //   }
            // }
          }
          .preview-button {
            position: absolute;
            right: 10px;
            top: -4px;
            padding: 5px 15px;
            vertical-align: top;
          }
        }
        .print-handsongtable {
          margin: 0 auto;
        }
        .print-handsongtable-box {
          margin: 0 auto;
          background: #fff;
          padding: 20px 40px 0;
          height: calc(100% - 80px);
          >div.handsontable{
            height: calc(100% - 20px);
            overflow: hidden;
            .ht_master.handsontable {
              // height: 100%;
              margin-bottom: 10px;
              overflow: auto;
            }
          }

        }
        .handsontable .current.highlight {
          background: rgba(239, 245, 250, 1);
        }
        .handsontable td.area:before,
        .handsontable td.area-1:before,
        .handsontable td.area-2:before,
        .handsontable td.area-3:before,
        .handsontable td.area-4:before,
        .handsontable td.area-5:before,
        .handsontable td.area-6:before,
        .handsontable td.area-7:before {
          background: skyblue;
        }
        .ht_clone_top.handsontable, .ht_clone_top.handsontable> .wtHolder {
          width: 100% !important;
        }
        .wtHolder {
          // width: 100% !important;
          td {
            font-size: 14px;
            line-height: 1.2;
            background: 0 0;
            position: relative;
            text-align: left;
            vertical-align: middle;
            &.borderAll {
              border: 1px solid #2B3441;
            }
            &.borderRight {
              border-right: 1px solid #2B3441;
            }
            &.borderTop {
              border-top: 1px solid #2B3441;
            }
            &.borderBottom {
              border-bottom: 1px solid #2B3441;
            }
            &.borderLeft {
              border-left: 1px solid #2B3441;
            }
            &.fontFamily黑体 {
              font-family: SimHei, STHeiti;
            }
            &.fontFamily楷体 {
              font-family: KaiTi, STKaiti;
            }
            &.fontFamily宋体 {
              font-family: SimSun;
            }
            &.fontFamily微软雅黑 {
              font-family: Microsoft YaHei;
            }
            &.fontSize8 {
              font-size: 10px;
            }
            &.fontSize9 {
              font-size: 12px;
            }
            &.fontSize10 {
              font-size: 14px;
            }
            &.fontSize12 {
              font-size: 16px;
            }
            &.fontSize14 {
              font-size: 18px;
            }
            &.fontSize16 {
              font-size: 22px;
            }
            &.fontSize18 {
              font-size: 24px;
            }
            &.fontSize24 {
              font-size: 32px;
            }
            &.fontSize30 {
              font-size: 40px;
            }
            &.fontSize36 {
              font-size: 48px;
            }
            &.bold {
              font-weight: 700;
            }
            &.verticalAlign0 {
              vertical-align: top;
            }
            &.verticalAlign1 {
              vertical-align: middle;
            }
            &.verticalAlign2 {
              vertical-align: bottom;
            }
            &.paragraphAlign0 {
              text-align: left;
            }
            &.paragraphAlign1 {
              text-align: center;
            }
            &.paragraphAlign2 {
              text-align: right;
            }
            &.italic {
              font-style: italic;
            }
            &.underline {
              text-decoration: underline;
            }
            .print-image-value {
              width: 100%;
              height: 100%;
              display: block;
              background-size: contain;
              background-repeat: no-repeat;
            }
            > .content {
              overflow: hidden;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
          }
        }
        .page_split {
          width: 100%;
          height: 2px;
          background-color: #646464;
          position: absolute;
          z-index: 2;
          left: 0;
        }
      }
    }
    .page-size-dialog {
      .el-dialog.el-dialog--center {
        margin-top: 14% !important;
      }
      color: #000;
      p {
        display: inline-block;
        margin-right: 9px;
      }
      .default-size {
        margin: 23px auto;
        .mr20 {
          margin-left: 40px;
          margin-right: 10px;
        }
        .mr10 {
          margin-right: 10px;
        }
      }
      .el-select,
      .el-select .el-input {
        width: 328px;
      }
      .el-input {
        width: 96px;
      }
      .dialog-footer {
        .el-button--mini,
        .el-button--mini.is-round {
          padding: 5px 20px;
        }
      }
    }
    .preview-dialog {
      .el-dialog__header {
        background: #fff;
      }
      img {
        width: 100%;
        display: block;
      }
    }
  }
  .el-tooltip__popper {
    padding: 5px;
  }
  .dropdown-with-img.el-dropdown-menu {
    li.el-dropdown-menu__item {
      text-align: left;
      img {
        width: 14px;
        height: 14px;
        display: inline-block;
        vertical-align: text-top;
        margin-right: 11px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/custom-print.vue